module.exports = __webpack_public_path__ + "media/images/devices-ca9af4c10985b7452de56a6905e27cb4.png";